import React, {useRef, useEffect, useState} from 'react';
import styled from 'styled-components';
import {useSize} from 'ahooks';

const StyledContent = styled.div`
${({imageHeight}) => `
& {
  .category-card {
    .category-card-item {
      .category-card-item-image-wrapper {
        height: ${!imageHeight ? 'unset' : `${imageHeight}px`};
      }
    }
  }
}
`}
`;

const Content = ({configData}) => {
  const listRef = useRef(null);
  const containerSize = useSize(listRef);
  const [imageHeight, setImageHeight] = useState(0);
  useEffect(() => {
    if (containerSize && containerSize.width) {
      setImageHeight(((containerSize.width - 9) / 2) * 0.5625);
    }
  }, [containerSize]);
  return (
    <div className='tutorial-mobile-content'>
      <StyledContent ref={listRef} imageHeight={imageHeight}>
        {
          configData.map((category, index) => (
            <div className='category'>
              <div className='category-header'>
                <div className='category-header-order'>
                  <div className='category-header-order-back' />
                  <div className='category-header-order-num'>{index + 1}</div>
                </div>
                <span className='category-header-category'>{category.category}</span>
              </div>
              <div className='category-card'>
                {category.item.map((card) => (
                  <div className='category-card-item' onClick={() => window.open(card.url)}>
                    <div className='category-card-item-image-wrapper'>
                      <img alt='' className='category-card-item-image' src={require(`~/${card.image}`)} />
                      <div className='cover-opacity' />
                    </div>
                    <div className='category-card-item-content'>
                      <div className='category-card-item-content-name'>{card.name}</div>
                      <div div className='category-card-item-content-description'>{card.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        }
      </StyledContent>
    </div>
  );
};

export default Content;
